// Builds schema.org JSON-LD for brand pages: Brand + CollectionPage + BreadcrumbList.

const SITE_URL = "https://www.extremeperformance.com";
const WEBSITE_ID = `${SITE_URL}/#website`;

// breadcrumb = [{ name, url }, ...] from Home to the current page
export const buildBrandPageSchema = ({ name, url, description, logo, breadcrumb }) => {
    if (!name || !url) return null;

    const brand = {
        "@type": "Brand",
        "@id": `${url}#brand`,
        name,
        url,
    };
    if (description) brand.description = description;
    if (logo) brand.logo = logo;

    const page = {
        "@type": "CollectionPage",
        "@id": `${url}#page`,
        url,
        name,
        about: { "@id": `${url}#brand` },
        isPartOf: { "@id": WEBSITE_ID },
    };
    if (description) page.description = description;

    const graph = [brand, page];

    if (breadcrumb && breadcrumb.length > 0) {
        graph.push({
            "@type": "BreadcrumbList",
            itemListElement: breadcrumb.map((crumb, index) => ({
                "@type": "ListItem",
                position: index + 1,
                name: crumb.name,
                item: crumb.url,
            })),
        });
    }

    return { "@context": "https://schema.org", "@graph": graph };
};

export const brandBreadcrumb = (name, url) => [
    { name: "Home", url: `${SITE_URL}/` },
    { name: "Brands", url: `${SITE_URL}/brands` },
    { name, url },
];
